import Cloudservice from './Cloudservice';
export default Cloudservice;
